import { getUUID } from './get-uuid';
export const generateClientId = getUUID;